import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'percentValue'
})
export class PercentValuePipe implements PipeTransform {
    public transform(value: number| string, args: number = 2): string {
        if (!(value === null || value === undefined)) {
            return `${Number(value).toFixed(args)}%`;
        } else {
            return '0.0%';
        }
    }
}
